import { getFormDefinition, createFormDataFromItem, createItemFromFormData } from './form';
import { entityToStore } from '@/utils/store';
import baseCrudMixin from '@/mixins/crud';
import { closeCurrentTag } from '@/utils/tags';
import { toISOString } from '@/utils/date';
export default {
  computed: {
    definition() {
      return this.createDefinition();
    },
    entityStore() {
      return entityToStore(this.entity);
    }
  },
  mixins: [baseCrudMixin],
  data: () => ({
    entity: 'TransportOrder',
    returnTo: 'TransportOrders',
    exporting: false
  }),
  created() {
    this.$store.dispatch('truck/getItems');
  },
  methods: {
    createDefinition() {
      return getFormDefinition(this);
    },
    async exportShipments(useBlackHole) {
      // truckIdentifier and shipmentAt may have changed, so save before exporting
      // this transport order.
      const persist = await this.$refs.editor.persistForm();
      if (!persist) {
        console.log('save failed');
        return;
      }

      const message = useBlackHole
        ? this.$i18n.t('transportOrder.confirmExportToBlackHole')
        : this.$i18n.t('transportOrder.confirmExport');

      this.$store
        .dispatch('notify/confirm', { message: message })
        .then(() => {
          const form = this.$store.getters['editor/flattenedForm'];
          if (form.exportedAt) {
            this.$store
              .dispatch('notify/confirm', { message: this.$i18n.t('transportOrder.confirmAlreadyExportedExport') })
              .then(() => {
                this.doExportShipments(useBlackHole);
              })
              .catch(() => {
                console.log('export cancelled by user');
              });
          } else {
            this.doExportShipments(useBlackHole);
          }
        })
        .catch(() => {
          console.log('export cancelled by user');
        });
    },
    doExportShipments(useBlackHole) {
      this.exporting = true;
      const form = this.$store.getters['editor/flattenedForm'];
      const exportShipmentsCommand = {
        transportOrders: [form.id]
      };
      const action = useBlackHole ? 'transportOrder/exportShipmentsToBlackHole' : 'transportOrder/exportShipments';
      this.$store
        .dispatch(action, exportShipmentsCommand)
        .then(result => {
          this.exporting = false;
          this.$store.dispatch('notify/success', { message: this.$i18n.t('transportOrder.shipmentsExported') });
          if (this.getRouteOnSave) {
            closeCurrentTag(this, this.getRouteOnSave(), false);
          } else {
            closeCurrentTag(this, false, { name: this.returnTo });
          }
        })
        .catch(error => {
          console.error(error);
          this.exporting = false;
          this.$store.dispatch('notify/error', { message: this.$i18n.t('transportOrder.shipmentsExportError') });
        });
    },
    async updateOrderLineDeliveryDate() {
      try {
        await this.$store.dispatch('notify/confirm', {
          message: this.$i18n.t('transportOrder.confirmFixDeliveryDate')
        });
      } catch {
        return;
      }
      const form = this.$store.getters['editor/flattenedForm'];
      this.exporting = true;
      try {
        await this.$store.dispatch('transportOrder/updateOrderLineDeliveryDate', {
          id: form.id,
          deliveryDate: toISOString(form.shipmentAt)
        });
      } finally {
        this.exporting = false;
      }
    },
    createFormDataFromItem,
    createItemFromFormData
  }
};
